import { AsyncPipe } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { ProfileFacade } from '@app/store/profile';
import { AvatarComponent, LogoComponent } from '@shared/components';
import { MediaSrcPipe } from '@shared/pipes/media-src.pipe';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    imports: [AsyncPipe, RouterLink, ButtonModule, LogoComponent, AvatarComponent, MediaSrcPipe],
})
export class HeaderComponent {
    private readonly profileFacade = inject(ProfileFacade);

    readonly profile = this.profileFacade.profile;

    readonly initials = computed(() => {
        const user = this.profile();
        if (!user) return '';
        return `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`.toUpperCase();
    });

    constructor() {
        this.profileFacade.getProfile();
    }
}
